import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/default.css";
import VTooltip from "v-tooltip";
import app_config from "./app_config.json";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VueGtag from "vue-gtag";
import TawkMessengerVue from "@tawk.to/tawk-messenger-vue-2";

Vue.use(TawkMessengerVue, {
  propertyId: "65aae6f98d261e1b5f5594e2",
  widgetId: "1hkhpcfnd",
});

Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.GA_TRACK_ID,
      params: {
        send_page_view: false,
      },
    },
  },
  router
);

Vue.use(VueReCaptcha, { siteKey: process.env.CAPTCHA_KEY });

Vue.use(VTooltip);
Vue.config.productionTip = false;
Vue.config.ignoredElements = ["pink"];

Vue.filter("toCurrency", function (value: any) {
  if (typeof value !== "number") {
    return value;
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
});

Vue.filter("toCurrencyNoDecimal", function (value: any) {
  if (typeof value !== "number") {
    return value;
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
